module.exports = __webpack_public_path__ + "img/2-2.9e73027d.png";